import * as yup from 'yup';
const validation = {
  personalInformation: yup.object({
    userType: yup.string().required('User type is required.'),
    fullName: yup.string().required('Full name is required.'),
    emailAddress: yup.string().required('Email address is required.'),
    mobileNumber: yup.string().required('Mobile number is required.'),
  }),
  contactInformation: yup.object({
    address1: yup.string().required('Address Line 1 is required.'),
    address2: yup.string().required('Address Line 2 is required.'),
    city: yup.string().required('City name is required.'),
    country: yup.string().required('Country name is required.'),
    postalCode: yup.string().required('Postal code is required.'),
  }),
  companyDetails: yup.object({
    companyName: yup.string().required('Company Name is required'),
  }),
};

export default validation;
